import React, { useState } from 'react';
import { Layout, Menu, theme } from 'antd';
import type { MenuProps } from 'antd';
import {
  BookOutlined,
  NodeIndexOutlined,
  ContainerOutlined,
  TeamOutlined,
  ExperimentOutlined,
  ApartmentOutlined,
  SettingOutlined,
  BranchesOutlined,
  DatabaseOutlined
} from '@ant-design/icons';

import DomainModelView from './components/DomainModelView';
import EntityRelationshipView from './components/EntityRelationshipView';
import ConceptExplainer from './components/ConceptExplainer';
import CustomerMasterData from './components/CustomerMasterData';
import InteractiveDesignTutorial from './components/InteractiveDesignTutorial';
import EnhancedEntityDiagram from './components/EnhancedEntityDiagram';
import BusinessProcessManager from './components/BusinessProcessManager';
import ProcessIntegration from './components/ProcessIntegration';
import KnowledgeBaseSearch from './components/KnowledgeBaseSearch';
import ProcessDocumentCenter from './components/ProcessDocumentCenter';

import './App.css';
import './styles/charts.css';

const { Content, Sider } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

const items: MenuItem[] = [
  {
    key: 'process-center',
    icon: <BranchesOutlined />,
    label: '📌 流程文档中心',
    style: { fontWeight: 'bold', color: '#1890ff' }
  },
  {
    type: 'divider',
  },
  {
    key: 'concepts',
    icon: <BookOutlined />,
    label: 'DDD核心概念',
  },
  {
    key: 'domain-model',
    icon: <NodeIndexOutlined />,
    label: '领域建模原理',
  },
  {
    key: 'entity-relationship',
    icon: <ContainerOutlined />,
    label: '实体关系设计',
  },
  {
    key: 'customer-master-data',
    icon: <TeamOutlined />,
    label: '主数据架构设计',
  },
  {
    key: 'interactive-tutorial',
    icon: <ExperimentOutlined />,
    label: '交互式建模工具',
  },
  {
    key: 'enhanced-diagram',
    icon: <ApartmentOutlined />,
    label: '关系图谱展示',
  },
  {
    type: 'divider',
  },
  {
    key: 'process-manager',
    icon: <SettingOutlined />,
    label: '流程设计管理',
  },
  {
    key: 'process-integration',
    icon: <BranchesOutlined />,
    label: '流程整合分析',
  },
  {
    key: 'knowledge-base',
    icon: <DatabaseOutlined />,
    label: 'AI 智能助手',
  },
];

const App: React.FC = () => {
  const [selectedKey, setSelectedKey] = useState('process-center');
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const renderContent = () => {
    switch (selectedKey) {
      case 'process-center':
        return <ProcessDocumentCenter />;
      case 'concepts':
        return <ConceptExplainer />;
      case 'domain-model':
        return <DomainModelView />;
      case 'entity-relationship':
        return <EntityRelationshipView />;
      case 'customer-master-data':
        return <CustomerMasterData />;
      case 'interactive-tutorial':
        return <InteractiveDesignTutorial />;
      case 'enhanced-diagram':
        return <EnhancedEntityDiagram />;
      case 'process-manager':
        return <BusinessProcessManager />;
      case 'process-integration':
        return <ProcessIntegration />;
      case 'knowledge-base':
        return <KnowledgeBaseSearch />;
      default:
        return <ProcessDocumentCenter />;
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => {
          console.log(broken);
        }}
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
      >
        <div className="demo-logo-vertical" style={{ 
          height: 32, 
          margin: 16, 
          background: 'rgba(255, 255, 255, 0.3)',
          borderRadius: 6,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '14px',
          fontWeight: 'bold'
        }}>
          主数据项目辅助系统
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={items}
          onClick={({ key }) => {
            setSelectedKey(key);
            // 切换菜单时清理URL参数
            if (window.location.search) {
              window.history.replaceState({}, '', window.location.pathname);
            }
          }}
        />
      </Sider>
      <Layout>
        <Content style={{ margin: '24px 16px 0' }}>
          <div
            style={{
              padding: 24,
              minHeight: 360,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            {renderContent()}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
